module.exports = new __parcel__URL__("the-legend-of-zelda-the-minish-cap.2f8e1404.jpg").toString();